import { EOrderStatus } from "../interfaces/IQuery";
import { IColor } from "./selectColors";

interface IOrderStatusInfo {
  label: string;
  color: IColor;
}

export function orderStatusInfo(
  status: EOrderStatus | string
): IOrderStatusInfo {
  const statusMap: Record<
    EOrderStatus | string,
    { label: string; color: IColor }
  > = {
    [EOrderStatus.ALL]: {
      label: "global.order_status.all",
      color: IColor.blue,
    },
    [EOrderStatus.NEW]: {
      label: "global.order_status.new",
      color: IColor.green,
    },
    [EOrderStatus.PARTIALLY_FILLED]: {
      label: "global.order_status.partially_filled",
      color: IColor.orange,
    },
    [EOrderStatus.FILLED]: {
      label: "global.order_status.filled",
      color: IColor.success,
    },
    [EOrderStatus.DONE_FOR_DAY]: {
      label: "global.order_status.done_for_day",
      color: IColor.violet,
    },
    [EOrderStatus.CANCELED]: {
      label: "global.order_status.canceled",
      color: IColor.red,
    },
    [EOrderStatus.REPLACED]: {
      label: "global.order_status.replaced",
      color: IColor.purple,
    },
    [EOrderStatus.PENDING_CANCEL]: {
      label: "global.order_status.pending_cancel",
      color: IColor.waiting,
    },
    [EOrderStatus.STOPPED]: {
      label: "global.order_status.stopped",
      color: IColor.disapproved,
    },
    [EOrderStatus.REJECTED]: {
      label: "global.order_status.rejected",
      color: IColor.red,
    },
    [EOrderStatus.SUSPENDED]: {
      label: "global.order_status.suspended",
      color: IColor.orange,
    },
    [EOrderStatus.PENDING_NEW]: {
      label: "global.order_status.pending_new",
      color: IColor.waiting,
    },
    [EOrderStatus.CALCULATED]: {
      label: "global.order_status.calculated",
      color: IColor.babyBlue,
    },
    [EOrderStatus.EXPIRED]: {
      label: "global.order_status.expired",
      color: IColor.yellow,
    },
    [EOrderStatus.ACCEPTED_FOR_BIDDING]: {
      label: "global.order_status.accepted_for_bidding",
      color: IColor.blue,
    },
    [EOrderStatus.PENDING_REPLACE]: {
      label: "global.order_status.pending_replace",
      color: IColor.waiting,
    },
  };

  const selected = statusMap[status] || {
    label: "global.order_status.unknown",
    color: IColor.red,
  };
  return {
    label: selected.label,
    color: selected.color,
  };
}
